import { useEffect, useState } from "react";
import CustomersPanel from "./components/customer/CustomerPanel";
import CustomerSelection from "./components/customer/CustomerSelection";
import Footer from "./components/Footer";
import FormsPanel from "./components/form/FormsPanel";
import HorizontalNavigation, { ApplicationTab } from "./components/HorizontalNavigation";
import KitsPanel from "./components/kit/KitsPanel";
import MaterialsPanel from "./components/material/MaterialsPanel";
import OrdersPanel from "./components/order/OrdersPanel";
import PricingsPanel from "./components/pricing/PricingsPanel";
import PricingGroupPanel from "./components/pricinggroup/PricingGroupPanel";
import ShapesPanel from "./components/shape/ShapesPanel";
import PriceListSelection from "./components/pricing/PriceListSelection";
import SpringMaterialsPanel from "./components/springmaterial/SpringMaterialsPanel";
import BonnellSpringsPanel from "./components/bonnellspring/BonnellSpringsPanel";
import PocketSpringsPanel from "./components/pocketspring/PocketSpringsPanel";
import { ReactKeycloakProvider } from "@react-keycloak/web";
import keycloak from "./keycloak";

export const COMPANY_NAME = 'Vertus';

const customerSelectionApplicationTabs = [
  ApplicationTab.Customers,
  ApplicationTab.Pricing,
  ApplicationTab.Forms,
  ApplicationTab.Shapes,
  ApplicationTab.Kits,
  ApplicationTab.Orders,
  ApplicationTab.BonnellSprings,
  ApplicationTab.PocketSprings
];

const priceListSelectionApplicationTabs = [
  ApplicationTab.Pricing,
  ApplicationTab.Forms,
  ApplicationTab.Shapes,
  ApplicationTab.Kits,
  ApplicationTab.BonnellSprings,
  ApplicationTab.PocketSprings
];

export default () => {
  const [tabId, setTabId] = useState<ApplicationTab>(ApplicationTab.Customers);
  const [customerId, setCustomerId] = useState<number|null>(null);
  const [priceListId, setPriceListId] = useState<number|null>(null);
  const handleCustomerSelected = (customerId: number|null) => setCustomerId(customerId);
  const handlePriceListSelected = (priceListId: number) => setPriceListId(priceListId);

  useEffect(() => {
    document.title = COMPANY_NAME;
  }, []);

  return (
    <div className='application'>
      <ReactKeycloakProvider
        authClient={ keycloak }
        initOptions={{ onLoad: 'login-required' }}
      >
        <HorizontalNavigation
          selectedTab={tabId}
          onTabChange={setTabId}
          customerSelected={ customerId != null } />
        { customerSelectionApplicationTabs.includes(tabId) && <CustomerSelection
          defaultCustomerId={ customerId }
          onCustomerSelected={ handleCustomerSelected }
        /> }
        { priceListSelectionApplicationTabs.includes(tabId)
          && <PriceListSelection
                defaultPriceListId={ priceListId == null ? undefined : priceListId }
                onPriceListSelected={ handlePriceListSelected }
                enableMutations={ tabId === ApplicationTab.Pricing }
              />}
        {tabId === ApplicationTab.Customers
          && <CustomersPanel />}
        {tabId === ApplicationTab.Materials
          && <MaterialsPanel />}
        {tabId === ApplicationTab.SpringsMaterials
          && <SpringMaterialsPanel />}
        {tabId === ApplicationTab.PricingGroups
          && <PricingGroupPanel />}
        {customerId !== null && priceListId !== null && tabId === ApplicationTab.Pricing
          && <PricingsPanel customerId={ customerId } priceListId={ priceListId } />}
        {customerId !== null && priceListId !== null && tabId === ApplicationTab.Forms
          && <FormsPanel customerId={ customerId } priceListId={ priceListId } />}
        {customerId !== null && priceListId !== null && tabId === ApplicationTab.Shapes
          && <ShapesPanel customerId={ customerId } priceListId={ priceListId } />}
        {customerId !== null && priceListId !== null && tabId === ApplicationTab.Kits
          && <KitsPanel customerId={ customerId } priceListId={ priceListId } />}
        {customerId !== null && priceListId !== null && tabId === ApplicationTab.BonnellSprings
          && <BonnellSpringsPanel customerId={ customerId } priceListId={ priceListId } />}
        {customerId !== null && priceListId !== null && tabId === ApplicationTab.PocketSprings
          && <PocketSpringsPanel customerId={ customerId } priceListId={ priceListId} />}
        {tabId === ApplicationTab.Orders && <OrdersPanel customerId={ customerId } />}
        <Footer />
      </ReactKeycloakProvider>
    </div>
  );
}